<template>
    <div class="c-loading" id="progressMask">
        <div class="progress-box">
            <div class="progress-gear">
                <img src="../../assets/image/c-loading/progress_gear.gif">
            </div>
            <div class="progress-text">正在加载，请稍后...</div>
        </div>
        <div class="progress-bottom">
            <div class="progress-content">
                <div class="progress-content-top">
                    <div>初始化</div>
                    <div class="progress-step-dot">
                        <img src="../../assets/image/c-loading/progress_dot.png">
                    </div>
                    <div>连接服务器</div>
                    <div class="progress-step-dot">
                        <img src="../../assets/image/c-loading/progress_dot.png">
                    </div>
                    <div>加载应用资源</div>
                    <div class="progress-step-dot">
                        <img src="../../assets/image/c-loading/progress_dot.png">
                    </div>
                    <div>正在启动</div>
                    <div class="progress-step-dot">
                        <img src="../../assets/image/c-loading/progress_dot.png">
                    </div>
                </div>
                <div class="progress-content-bar">
                    <div class="progress-active" :style="{width:time+'%'}"></div>
                    <div class="progress-slide">
                        <img class="progress-rocket" src="../../assets/image/c-loading/progress_rocket.gif" />
                    </div>
                    <div class="progress-per">{{time}}%</div>
                </div>
            </div>

        </div>
        <!-- <div class="loading_box">
            <div class="loading" id="loading"></div>
            <div class="loading_size">游戏正在加载中，请耐心等待{{ time }}秒钟~</div>
        </div> -->
    </div>
</template>

<script>
import lottie from 'lottie-web';
import animationData from "../../assets/image/icon/loading.json";
export default {
    name: "c-loading",
    data() {
        return {
            time: 0,
            timeWare: null,
            cloudappProgress:null
        }
    },
    created() {
        this.countDown()
    },
    mounted() {
        this.$nextTick(() => {
            
            // this.init()
        })
    },
    beforeDestroy() {
        this.clearTime()
    },
    methods: {
        initaProgress() {
            this.cloudappProgress = new CloudappProgress({
                mask: "progressMask",
                active: "progressActive",
                per: "progressPer"
            });
        },
        init() {
            let path = require("../../assets/image/icon/atpay.json")
            console.log(lottie, 'lottie');
            lottie.loadAnimation({
                container: document.querySelector("#loading"), // 替换为你的容器元素的ID  
                renderer: 'svg', // 或者 'canvas' 或 'html'  
                loop: true,
                autoplay: true,
                animationData: path,
            });
            // const animation = lottie.loadAnimation()
        },
        countDown() {
            this.timeWare = setInterval(() => {
                if (this.time >= 99) {
                    this.clearTime()
                    return
                }
                this.time += 1
            }, 10)
        },
        clearTime() {
            if (this.timeWare) {
                clearInterval(this.timeWare)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.c-loading {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;

    .loading_box {
        font-size: .213333rem
            /* 16/75 */
        ;
        color: #fff;
        text-align: center;
        position: relative;

        .loading {
            width: 1.066667rem
                /* 80/75 */
            ;
            height: 1.066667rem
                /* 80/75 */
            ;
        }

        .loading_size {
            position: absolute;
            left: 50%;
            right: 50%;
            transform: translate(-50%);
            bottom: 0;
            width: 100%;
            white-space: nowrap;
            width: 8rem
                /* 600/75 */
            ;
            text-align: center;
        }

    }

    .progress-box {
        position: absolute;
        top: 40%;
        transform: translateY(-50%);
        width: 100%;
        text-align: center;
        font-size: .186667rem /* 14/75 */;
        color: #ffffff;

        .progress-gear {
            margin: auto;
            width: .8rem /* 60/75 */;
            height: .8rem /* 60/75 */;

            >img {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
        .progress-text {
                margin-top: .266667rem
                    /* 20/75 */
                ;
            }

    }

    .progress-bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        height: 1.333333rem
            /* 100/75 */
        ;
        background-image: url("../../assets/image/c-loading/progress_bottom.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .progress-bottom_box {
            margin: 0 auto;
        }

        .progress-content {
            margin: 0 auto;
            width: 80%;
            ;

            .progress-content-top {
                text-align: center;
                font-size: .16rem;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: space-between;

                >div {
                    flex-shrink: 0;
                }

                .progress-step-dot {
                    width: .24rem
                        /* 18/75 */
                    ;
                    height: .133333rem
                        /* 10/75 */
                    ;

                    >img {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

        .progress-content-bar {
            position: relative;
            display: flex;
            height: .106667rem /* 8/75 */;
            background: #000000;
            border: 1px solid #8B7833;
            padding: .026667rem
                /* 2/75 */
            ;
            border-radius: .08rem /* 6/75 */;
            margin: .133333rem auto;
            .progress-per{
                position: absolute;
                right: -.733333rem /* 55/75 */;
                top: 0;
                color: #fff;
                font-size: .16rem /* 12/75 */;
            }
            .progress-active {
                background: #FFD88C;
                border-radius: .026667rem
                    /* 2/75 */
                ;
                width: 0%;
                transition: 0.2s width ease-in-out;
            }

            .progress-slide {
                display: inline-block;
                position: relative;
                width: 1px;
                height: 100%;

                .progress-rocket {
                    position: absolute;
                    transform: translate(-50%, -50%);
                    top: 50%;
                    margin-top: -.026667rem
                        /* 2/75 */
                    ;
                    height: .48rem
                        /* 36/75 */
                    ;
                }
            }
        }
    }
}
</style>